import { NgModule } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
@NgModule({
  declarations: [],
  imports: [DragDropModule],  
  exports: [DragDropModule],
})
export class MaterialModule {}
